import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/HomePage";
import HostLobby from "./pages/HostLobby";
import JoinPage from "./pages/JoinPage";
import PlayerController from "./pages/PlayerController";
import AboutPage from "./pages/AboutPage";
import ProPage from "./pages/ProPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import BusinessPage from "./pages/BusinessPage";
import BugReport from "./components/BugReport";
import Footer from "./components/Footer";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import OfferPage from "./pages/OfferPage";
import AdminPage from "./pages/AdminPage";
import HowToPlayPage from "./pages/HowToPlayPage";
import NewsPage from "./pages/NewsPage";
import "./App.css";
import { initGlobalErrorCapture } from "./hooks/useLogger";
initGlobalErrorCapture();

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const LIGHTS = [
  { x:  8, y: 12, rx: 26, ry: 18, color: "255,60,172",  dur: 7,  delay: 0   },
  { x: 92, y:  8, rx: 22, ry: 16, color: "0,245,255",   dur: 9,  delay: 1.5 },
  { x: 75, y: 88, rx: 24, ry: 17, color: "255,230,0",   dur: 11, delay: 0.8 },
  { x: 18, y: 80, rx: 20, ry: 15, color: "61,255,160",  dur: 8,  delay: 2.2 },
  { x: 50, y: 48, rx: 18, ry: 13, color: "155,93,229",  dur: 13, delay: 0.4 },
  { x: 35, y: 25, rx: 16, ry: 12, color: "255,140,0",   dur: 10, delay: 3.1 },
  { x: 80, y: 42, rx: 19, ry: 14, color: "255,60,172",  dur: 12, delay: 1.0 },
  { x: 22, y: 45, rx: 17, ry: 13, color: "0,245,255",   dur: 9,  delay: 2.7 },
  { x: 63, y: 15, rx: 21, ry: 15, color: "255,60,172",  dur: 14, delay: 0.3 },
  { x: 88, y: 62, rx: 15, ry: 12, color: "61,255,160",  dur: 8,  delay: 1.8 },
  { x: 42, y: 75, rx: 20, ry: 14, color: "155,93,229",  dur: 11, delay: 3.5 },
  { x: 58, y: 35, rx: 14, ry: 11, color: "255,230,0",   dur: 7,  delay: 2.0 },
];

function NeonLights() {
  return (
    <div style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 0, overflow: "hidden" }}>
      {LIGHTS.map((l, i) => (
        <div key={i} style={{
          position: "absolute",
          left: `${l.x}%`, top: `${l.y}%`,
          width: `${l.rx * 2}vw`, height: `${l.ry * 2}vh`,
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
          background: `radial-gradient(ellipse at center, rgba(${l.color},0.22) 0%, transparent 70%)`,
          animation: `neon-flicker ${l.dur}s ease-in-out ${l.delay}s infinite alternate`,
          willChange: "opacity",
        }} />
      ))}
    </div>
  );
}

const COMING_SOON = process.env.REACT_APP_COMING_SOON === "true";

function GameRoute({ element }) {
  if (COMING_SOON) return <Navigate to="/" replace />;
  return element;
}

function App() {
  return (
    <div className="App min-h-screen" style={{ background: "#0d0820", position: "relative", zIndex: 0 }}>
      <NeonLights />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/games" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pro" element={<ProPage />} />
          <Route path="/business" element={<BusinessPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/offer" element={<OfferPage />} />
          <Route path="/host/:roomId" element={<GameRoute element={<HostLobby />} />} />
          <Route path="/join" element={<GameRoute element={<JoinPage />} />} />
          <Route path="/play/:roomId" element={<GameRoute element={<PlayerController />} />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/how-to-play" element={<HowToPlayPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:newsId" element={<NewsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <BugReport />
      <Toaster position="top-center" />
    </div>
  );
}

export default App;